import { api } from "@/lib/axios";

export default function deleteOne(dealId: string) {
  return api.delete(`deals/${dealId}`);
}
